import React from "react";
import RadioAccordion from "../../elements/radio-accordion";
import PropTypes from "prop-types";
import "./style.scss";

const CarDeliveryOptions = radioAccordionProps => {
  return (
    <div className="car-delivery-options">
      <RadioAccordion {...radioAccordionProps} />
    </div>
  );
};

export default CarDeliveryOptions;
